import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=d7558e92"
import script from "./update-password.vue?vue&type=script&lang=js"
export * from "./update-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports